<template>
  <div>
    <div>我的收益</div>

    <div class="mt20">
      <div class="income-panel" style="padding-left: 64px">
        <div>剩余金额</div>

        <div class="fr jsb ac mt10">
          <div style="font-size: 30px;color: white">￥{{ member_balance.balance }}</div>
          <div
              class="withdraw-btn cursor"
              @click="go(`/myIncome/withdraw?can_withdraw_price=${member_balance.balance}`)"
          >提现
          </div>
        </div>

        <div class="fr ac mt20 balance-box">
          <div class="fc jc">
            <div class="fz20">￥{{ member_balance.total_income }}</div>
            <div class="mt10">累计金额</div>
          </div>
          <div class="fc jc">
            <div class="fz20">￥{{ member_balance.withdrawal_amount }}</div>
            <div class="mt10">已提现金额</div>
          </div>
          <div class="fc jc">
            <div class="fz20">￥{{ member_balance.withdrawal_ing_amount }}</div>
            <div class="mt10">正在提现</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt20">
      <div class="mt20 search">
        <el-date-picker
            v-model="time"
            size="small"
            :clearable="false"
            type="daterange"
            value-format="yyyy-MM-dd hh:mm:ss"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
        <el-button size="small" type="primary" @click="getMemberBalanceList">搜索</el-button>
      </div>
      <!--        表格-->
      <el-table :data="balance_list" style="width: 100%">
        <el-table-column align="center" prop="create_time" label="日期" width="180"></el-table-column>
        <el-table-column align="center" prop="balance_price" label="金额" width="180"></el-table-column>
        <el-table-column align="center" prop="balance_type" label="事件">
          <template slot-scope="scope">{{ scope.row.balance_type|filterBalanceType }}</template>
        </el-table-column>
        <el-table-column align="center" prop="order_no" label="备注"></el-table-column>
      </el-table>
    </div>
    <!--    分页-->
    <div class="fr jc ac mt30" v-if="false">
      <el-pagination
          background
          :current-page.sync="pagination.page"
          @current-change="getMemberBalanceList"
          layout="prev, pager, next"
          :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      member_balance: "",
      balance_list: [],
      time: [],
      pagination: {
        page: 1,
        total: 0,
      },
    };
  },
  filters: {
    filterBalanceType(v) {
      if (v == 1) {
        return "订单返佣";
      }
      if (v == 2) {
        return "提现";
      }
    },
  },
  mounted() {
    let start = `${this.formatDate(new Date(), 'yyyy-MM')}-01 00:00:00`
    let end = `${this.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')}`
    this.time = [start, end];
    this.getBalanceTotal();
    this.getMemberBalanceList();
  },
  methods: {
    //获取用户总余额
    getBalanceTotal() {
      this.post(this.$store.getters.getIncomeInfo).then((res) => {
        this.member_balance = res.data;
      });
    },
    //  获取用户余额明细列表
    getMemberBalanceList() {
      let param = {
        // page: this.pagination.page,
        start_time: this.time[0],
        end_time: this.time[1],
      };
      this.post(this.$store.getters.getBalanceRecordList, param).then(
          (res) => {
            this.balance_list = res.data;
            // this.pagination.total = res.total;
          }
      );
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.income-panel {
  color: white;
  width: 943px;
  height: 179px;
  background: rgba(69, 142, 246, 1);
  opacity: 1;
  padding: 25px;
}

.balance-box {
  display: grid;
  grid-template-columns: repeat(3, 20%);
  text-align: center;
}

.withdraw-btn {
  width: 142px;
  height: 44px;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #458ef6;
}
</style>


// WEBPACK FOOTER //
// src/page/me/myIncome/index.vue